import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Filtres } from 'src/app/utils/interfaces/new/filtres.interface';
import { Maquette } from 'src/app/utils/interfaces/new/Maquette';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';
import { environment } from 'src/environments/environment';
import { FiltresService } from '../filtres/filtres.service';
import { SnackbarService } from '../snackbar/snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class MaquetteService {

  private isMock = environment.mock;
  private _wait = (ms) => new Promise(res => setTimeout(res, ms));
  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };
  private uri = environment.basePath + "/personnalisation/maquettes";

  constructor(
    private http: HttpClient,
    private _filtresService: FiltresService,
    private _snack: SnackbarService
  ) { }

  public async create(maquette: Maquette): Promise<string> {
    try {
      const res = await this.http.post(this.uri, maquette, this.httpOptions).toPromise();
      const id = res.body as string;
      return id;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async find(filtre: Filtres = {
    perpage: -1,
    currentPage: 1,
    sortBy: 'name'
  }): Promise<Paginated<Maquette>> {
    try {
      this.httpOptions.headers = this._filtresService.setHeaders(filtre);
      const res = await this.http.get(this.uri, this.httpOptions).toPromise();
      const maquettes = res.body as Maquette[];
      const paginated: Paginated<Maquette> = {
        page: Number(res.headers.get('x-page')),
        perpage: Number(res.headers.get('x-per-page')),
        total: Number(res.headers.get('x-total')),
        objects: maquettes
      };
      return paginated;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async update(maquette: Maquette) {
    try {
      const res = await this.http.put(this.uri + "/" + maquette.id, maquette, this.httpOptions).toPromise();
      return;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async deleteMaquette(maquetteId: string) {
    try {
      await this.http.delete(`${this.uri}/${maquetteId}`, this.httpOptions).toPromise();
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }

  public async findOne(maquetteId: string): Promise<Maquette> {
    try {
      const res = await this.http.get(this.uri + "/" + maquetteId, this.httpOptions).toPromise();
      const critere = res.body as Maquette;
      return critere;
    } catch (error) {
      this._snack.openSnackBar(error.error.message);
    }
  }
}
